/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Email_PlaceholderInputs */

const es_cap_email_placeholder = /** @type {(inputs: Cap_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tucorreo@email.com`)
};

const gl_cap_email_placeholder = /** @type {(inputs: Cap_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oteucorreo@email.com`)
};

const en_cap_email_placeholder = /** @type {(inputs: Cap_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@email.com`)
};

/**
* | output |
* | --- |
* | "you@email.com" |
*
* @param {Cap_Email_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_email_placeholder = /** @type {((inputs?: Cap_Email_PlaceholderInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Email_PlaceholderInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_email_placeholder(inputs)
	if (locale === "en") return en_cap_email_placeholder(inputs)
	return es_cap_email_placeholder(inputs)
});